const KingdomOfSicily = {
  id: '11',
  name: 'Kingdom of Sicily'
};

export default KingdomOfSicily;
